import { FormControl, FormDescription, FormItem, FormMessage } from "@ui/shad"
import { ControllerRenderProps, FieldValues, Path } from "react-hook-form"

import { CheckboxInput } from "../inputs/checkbox-input"

interface CheckboxFieldProps<T extends FieldValues>
  extends Omit<React.ComponentProps<typeof CheckboxInput>, "checked" | "onChange" | "id"> {
  id: string
  description?: string
  field: ControllerRenderProps<T, Path<T>>
}

export function CheckboxField<T extends FieldValues>({ field, id, description, ...props }: CheckboxFieldProps<T>) {
  return (
    <FormItem>
      <FormControl>
        <CheckboxInput id={id} checked={field.value} onChange={field.onChange} {...props} />
      </FormControl>
      {description && <FormDescription>{description}</FormDescription>}
      <FormMessage />
    </FormItem>
  )
}

/* Example Usage:
interface FormData {
  terms: boolean;
}

<FormField
  control={form.control}
  name="terms"
  render={({ field }) => (
    <CheckboxField<FormData>
      field={field}
      id="terms"
      label="Accept terms and conditions"
      description="By checking this box, you agree to our Terms of Service."
    />
  )}
/>
*/
